import { opportunitySyncProfilesService } from '@/services/opportunity-sync-profiles.service';
import axios from 'axios';

const initialState = () => ({
  opportunitySyncProfiles: [],
  status: {
    error: null,
    pending: false,
    resolved: false,
    rejected: false,
  },
});

const state = initialState();

const actions = {
  getOpportunitySyncProfiles({ commit }, { cancelToken }) {
    commit('GET_OPPORTUNITY_SYNC_PROFILES');

    return opportunitySyncProfilesService.getOpportunitySyncProfiles(cancelToken).then(
      (response) => {
        commit('SUCCESS_GET_OPPORTUNITY_SYNC_PROFILES', response);
        return response;
      },
      (error) => {
        if (!axios.isCancel(error)) {
          commit('ERROR_GET_OPPORTUNITY_SYNC_PROFILES', error);
          throw error;
        }
      },
    );
  },
};

const mutations = {
  GET_OPPORTUNITY_SYNC_PROFILES(state) {
    state.status = {
      error: null,
      pending: true,
      resolved: false,
      rejected: false,
    };
  },
  SUCCESS_GET_OPPORTUNITY_SYNC_PROFILES(state, opportunitySyncProfiles) {
    state.status = {
      ...state.status,
      pending: false,
      resolved: true,
    };
    state.opportunitySyncProfiles = opportunitySyncProfiles;
  },
  ERROR_GET_OPPORTUNITY_SYNC_PROFILES(state, error) {
    state.status = {
      error,
      pending: false,
      resolved: false,
      rejected: true,
    };
  },
};

const getters = {
  opportunitySyncProfiles: (state) => state.opportunitySyncProfiles,

  // status
  error: (state) => state.status.error,
  pending: (state) => state.status.pending,
  rejected: (state) => state.status.rejected,
  resolved: (state) => state.status.resolved,
};

export const opportunitySyncProfiles = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
